import splitApi from "./emptySplitApi";

const formsApi = splitApi.injectEndpoints({
  endpoints: (build) => ({
    getDropdownList: build.query({
      query: (url) => url,
      providesTags: ["SelectOptions"],
      keepUnusedDataFor: 300,
    }),
    dropdownList: build.mutation({
      query: (url) => ({
        url,
        method: "GET",
      }),
    }),
    getAutoCompList: build.query({
      query: ({ url, params }) => ({
        url,
        params,
      }),
      // providesTags: ["License"],
    }),
    getApiData: build.query({
      query: ({ url, params }) => ({ url, params }),
      providesTags: ["License"],
    }),
    validateEmail: build.mutation({
      query: (body) => ({
        url: "/v1/validate/email",
        method: "POST",
        body,
      }),
    }),
    verifyAddress: build.mutation({
      query: (body) => ({
        url: "/api/address/validate",
        method: "POST",
        body,
      }),
    }),
    getGeoCode: build.mutation({
      query: (url) => ({ url, method: "GET" }),
    }),
    getData: build.mutation({
      query: ({ url, params, body }) => ({
        url,
        params,
        method: body ? "POST" : "GET",
        ...(body && { body }),
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetApiDataQuery,
  useLazyGetDropdownListQuery,
  useDropdownListMutation,
  useGetAutoCompListQuery,
  useValidateEmailMutation,
  useVerifyAddressMutation,
  useGetGeoCodeMutation,
  useGetDataMutation,
} = formsApi;
